import canUse from './canUse'
import Cookie from 'js-cookie'

const DeleteToken = () => {
    if (canUse()) {
        Cookie.remove('mss_token')
    }
}

export default DeleteToken
